import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml, Image, ApplyClassOnScroll, ApplyClassOnGroup } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  .HomeContent {
    overflow: hidden;
    padding: 110px 0 60px 0;
    position: relative;
    background-color: ${colors.white};
    z-index: 1;
    @media (min-width: 992px) {
      padding: 90px 0;
      background-color: ${colors.neutral};
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 55%;
        height: 50%;
        background-image: url('/images/pattern-02-light.svg');
        background-repeat: repeat;
        background-position: right top;
      }
    }
  }
  .HomeContent_sectionIntro {
    text-align: center;
  }
  .HomeContent_testimonial {
    padding: 30px;
    background-color: ${colors.white};
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media (min-width: 992px) {
      padding: 60px 90px;
      margin: 30px 0;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .HomeContent_testimonialImage {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center center;
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      width: 250px;
      height: 250px;
      margin: 0 45px 0 0;
    }
  }
  .HomeContent_testimonialContent {
    flex-grow: 1;
  }
  .HomeContent_testimonialText p {
    margin: 0 0 30px 0;
  }
  .HomeContent_testimonialName {
    font-size: 15px;
    margin: 0;
    font-weight: 700;
  }
  .HomeContent_testimonialLocation {
    font-size: 15px;
    margin: 0;
  }
`;

function HomeContent({ content }) {
  return (
    <div className={styles}>
      <div className="HomeContent">
        <ApplyClassOnScroll
          className="container"
          once
          triggerGroup="pageSection"
          invisible="invisible"
          visible="animate__animated animate__fadeInUp"
          offset={-500}
        >
          <div className="row">
            <div className="col-lg-6 mx-lg-auto">
              {
                get(content, '[0].section_heading') &&
                <PageSectionHeading h3={get(content, '[0].section_heading')} />
              }
              {
                get(content, '[0].section_intro') &&
                <div className="HomeContent_sectionIntro" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].section_intro'))} />
              }
            </div>
          </div>
          <div className="row">
            <ApplyClassOnGroup
              className="col-4 px-1 px-lg-3"
              group="pageSection"
              invisible="invisible"
              visible={{
                0: '',
                500: 'animate__animated animate__fadeInUp',
              }}
            >
              <Image
                src={get(content, '[0].image_1.contentUrl')}
                className="w-100"
                width={800}
                height={550}
                alt={get(content, '[0].image_1.name', '')}
                exact
              />
            </ApplyClassOnGroup>
            <ApplyClassOnGroup
              className="col-4 px-1 px-lg-3"
              group="pageSection"
              invisible="invisible"
              visible={{
                0: '',
                500: 'animate__animated animate__fadeInUp animate__delay-1s',
              }}
            >
              <Image
                src={get(content, '[0].image_2.contentUrl')}
                className="w-100 HomeContent_middleImage"
                width={800}
                height={550}
                alt={get(content, '[0].image_2.name', '')}
                exact
              />
            </ApplyClassOnGroup>
            <ApplyClassOnGroup
              className="col-4 px-1 px-lg-3"
              group="pageSection"
              invisible="invisible"
              visible={{
                0: '',
                500: 'animate__animated animate__fadeInUp animate__delay-2s',
              }}
            >
              <Image
                src={get(content, '[0].image_3.contentUrl')}
                className="w-100"
                width={800}
                height={550}
                alt={get(content, '[0].image_3.name', '')}
                exact
              />
            </ApplyClassOnGroup>
          </div>
          <div className="row">
            <div className="col-12">
              <ApplyClassOnGroup
                className="HomeContent_testimonial"
                group="pageSection"
                invisible="invisible"
                visible={{
                  0: '',
                  500: 'animate__animated animate__fadeIn animate__delay-3s',
                }}
              >
                <Image
                  src={get(content, '[0].testimonial_image.contentUrl')}
                  className="HomeContent_testimonialImage"
                  width={800}
                  height={550}
                  alt={get(content, '[0].image_3.name', '')}
                  exact
                />
                <div className="HomeContent_testimonialContent">
                  <div className="HomeContent_testimonialText" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].testimonial_text'))} />
                  <div>
                    <span className="HomeContent_testimonialName">{get(content, '[0].testimonial_name')}</span>
                    <span className="HomeContent_testimonialLocation"> | {get(content, '[0].testimonial_location')}</span>
                  </div>
                </div>
              </ApplyClassOnGroup>
              <div className="row justify-content-center">
                <Link name="testimonials" className="btn btn-brand2 btn-arrow-black">View All Testimonials</Link>
              </div>
            </div>
          </div>
        </ApplyClassOnScroll>
      </div>
    </div>
  );
}

HomeContent.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

HomeContent.defaultProps = {
};

export const sectionName = 'Home Conent';

export default HomeContent;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/HomeContent2.section.js